
import { defineComponent, ref, watch } from 'vue';
import customIcon from '@/components/toast/toastIcon.vue';
import MenuManager, { routerArr as baseRoute } from '@/utils/base/getMenu';

export default defineComponent({
    name: 'NewTree',
    props: {
        treeData: Array,
        distanceIndex: Number,
        point: Object,
    },
    setup(props, context) {
        const active = ref(undefined);
        const useName = {
            delete: '删除',
            add: '添加',
            edit: '编辑',
            look: '查看',
        };
        const routerArr = baseRoute;
        const getAllMenu = (routeList) => {
            const list = [];
            routeList.forEach((item) => {
                list.push(item);
                if (item.children && item.children.length > 0) {
                list.push(...getAllMenu(item.children));
                }
            });
            return list;
        };
        const allList = getAllMenu(routerArr);
        const checkMenuChild = (e) => {
            if (e.identify === '/school') {
                return false;
            }
            const cutInfo = e;
            const node = allList.find((item) => item.path === cutInfo.identify);
            return !!(node && node.children);
        };

        const addMenuById = (type, params) => {
            context.emit('addMenuById', type, params);
        };

        const addPerssionById = (params) => {
            context.emit('addPerssionById', params);
        };

        const toEdit = (params) => {
            context.emit('toEdit', params);
        };

        const toDelete = (params) => {
            context.emit('toDelete', params);
        };

        const checkSuperior = (item) => {
            setTimeout(() => {
                const useActive = item.active;
                const superior = props.point[item.pid];
                try {
                    if (superior.children && superior.children.length > 0) {
                            if (superior.pid !== 0) {
                                checkSuperior(superior);
                            }
                            superior.children.forEach((child) => {
                                if (child.active) {
                                    superior.indeterminate = true;
                                }
                                if (child.active !== useActive) {
                                    superior.indeterminate = true;
                                    throw (new Error('loop over'));
                                }
                            });
                            superior.active = useActive;
                            superior.indeterminate = false;
                    }
                } catch (error) {
                    try { 
                        superior.active = false;
                        superior.active = true;
                    } catch (error) {
                        
                    }
                }

                if (item.active) superior.active = true;
            }, 0);
        };
        // 全选反选
        const setChildActive = (arr, type) => {
            arr.forEach((item) => {
                item.active = type;
                if (item.children && item.children.length > 0) {
                setChildActive(item.children, type);
                }
            });
        };
        const selectAuthority = (item) => {
            if (item.children && item.children.length > 0) {
                setChildActive(item.children, item.active);
                if (item.active) {
                    item.indeterminate = false;
                }
            }
            checkSuperior(item);
        };
        return {
            props,
            useName,
            toEdit,
            toDelete,
            addMenuById,
            checkSuperior,
            selectAuthority,
            addPerssionById,
            checkMenuChild,
        };
    }
});
